// extracted by mini-css-extract-plugin
export default {"profileContainer":"HangoverTipForm_profileContainer__b6Y9z"};